<template>
    <div id="index" data-select2-id="index">
        <div>
            <div id="header" data-app-id="header" class="full-width base-container bg-theme">
                <div style="position: absolute;right: 20px;top: 20px;display:flex;z-index: 999">
                    <span id="id-login"
                        style="cursor: pointer;margin-right: 20px;display:inline-block;font-size: 14px;width:100px;border-right: 1px solid #fff;"
                        @click="tuichu" v-show="!userShow">
                        <img src="../../src/assets/images/退出.png" alt=""
                            style="width: 17px;height:17px;padding-bottom: 2px;">
                        退出登录</span>
                    <span id="id-login" style="cursor: pointer;margin-right: 20px;"
                        v-show="!userShow">当前用户:
                        {{ userName }}</span>
                    <span id="id-login"
                        style="cursor: pointer;display:inline-block;font-size: 14px;margin-right: 20px;width:115px;border-right: 1px solid #fff;color:#fff"
                        @click="denglu" v-show="userShow">
                        <img src="../../src/assets/images/登录.png" alt=""
                            style="width: 17px;height:17px;padding-bottom: 2px;">
                        你好,请登录</span>

                    <div id="id-login" style="cursor: pointer;;position:relative;width:120px">
                        <img src="../../src/assets/images/搜索.png" @click="searchStationList" alt=""
                            style="width: 17px;height:17px;padding-bottom: 2px;position:absolute;top:5px;right:7px;z-index: 99;">
                        <el-input class="input" @focus="focus" @blur="blurinput" ref="ipt"
                            :placeholder="placeholderValue" v-model="searchText"
                            @keyup.native.enter="searchStationList"></el-input>
                    </div>
                </div>
                <!--白色背景加上：bg-white；其他背景加上：.bg-deep-->
                <div class="pc-engine-item page-header page-header-style37 v4 custom-clip bg-scale-style4 bg-repeat-style1 bg-align-style5"
                    style="background:rgba(176,37,42,0);color: rgb(255, 255, 255);">
                    <div class="header-container clear">
                        <div class="img-logo">
                            <router-link :to="{ path: '/' }">
                                <img class="ui-cursor" src="../assets/images/Logo2.png">
                            </router-link>
                        </div>
                        <div class="fr" style="position: absolute;right: 0px;bottom: 0;">
                            <span class="menu-status icon-menu fl"></span>
                            <!-- <span class="obj-name overHidden1">西安电子科技大学图书馆</span> -->
                            <div class="top-box header-search-box clear" id="login-div" style="color:rgb(255, 255, 255)"
                                @mouseenter="move">
                                <div class="before-login-1 fr"
                                    style="display: block;color: rgb(255, 255, 255);font-size: 16px">
                                    <div class="item-drag-wrap text-module-container ui-resizable" style="">
                                        <div class="text-module item-content pointer"
                                            style="display:flex;align-items: flex-end;">
                                            <div class="item-main" style="float: left;"
                                                v-for="(item, index) in newKuaijie" :key="index">
                                                <p style="margin-right: 37px;cursor: pointer;">
                                                    <span style="font-size:14px" @click="kuaijieDatial(item, index)">
                                                        <span
                                                            style="color:#ffffff;font-size: 16px;font-weight: bold;">{{ item.name }}</span>
                                                    </span>
                                                </p>
                                            </div>
                                            <!-- <span id="id-login"
                                            style="cursor: pointer;margin-right: 20px;display:inline-block;margin-top: 20px;font-size: 14px;width:100px;border-right: 1px solid #fff;"
                                            @click="fanhui">
                                            <img src="../../src/assets/images/返回.png" alt=""
                                                style="width: 17px;height:17px;padding-bottom: 2px;">
                                            返回旧版</span> -->


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="header-nav-list clear">
                                <div class="item" v-for="(item, index) in newserjiArr" :key="index">
                                    <a class="hover-hand" @click="goDatial(item)">
                                        <span @mouseenter="move(item, index)">{{ item.name }}</span>
                                    </a>
                                    <div v-show="listNav ? index == indexNav : false" @mouseleave="remove">
                                        <div class="item-list nav-down-list is-long">
                                            <div class="li-second" v-for="(aa, b) in item.childDisease" :key="b">
                                                <a style="display: inline-block;height:100%;width:100%;"
                                                    @click="goDatialList(item, aa, b)">{{ aa.name }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserInfo, removeItem } from "@/common/utils/localStorage.js";
import { queryflxxbyCondition, queryTreeflxx, queryUserinfobycondition, searchStation } from "@/api/context1"//一二级分类
import { queryXwxxbyCondition, } from "@/api/news"//一二级分类信息
import Axios from "@/api/diyaxios";
// import bus from '../common/utils/bus'
import CoreCollapseTransition from '../components/CoreCollapseTransition'


export default {
    name: "detail",
    data() {
        return {
            newsArr: [],//新闻模块一级分类
            newserjiArr: [],//新闻模块二级分类
            listNav: false,
            indexNav: 0,
            topNavData: [],
            newKuaijie: [],
            KuaijieId: "",
            userName: "",
            link: "",
            userShow: true,
            userNameShow: false,
            parentId: "",
            searchText: "",//站内搜索
            placeholderValue: "站内搜索",
            pageNum: 1,
            pageSize: 10,
        };
    },
    components: {
        CoreCollapseTransition
    },
    created() {
        let vm = this;
        
        if (location.href.split('?')[1].split('=')[0] == "username") {
            this.$nextTick(() => {
                vm.link = location.href.split('?')[1].split('=')[1].substring(0, 11)
                vm.queryUserinfobycondition()
            });
        }
        vm.searchText = this.$route.query.title
    },
    mounted() {
        let vm = this;
        window.addEventListener('scroll', this.handleScroll, true)
        var that = this
        var inner = document.getElementsByClassName('h-800');
        window.onscroll = function () {
            // 获取滚动条距离页面底部的距离
            var tops = document.documentElement.scrollTop || document.body.scrollTop;
            // console.log(tops)
            //判断滚动的位置，从而改变楼层选项的样式
            for (var i = 0; i < inner.length; i++) {
                if (inner[i].offsetTop <= tops + 200 && tops <= inner[i].offsetTop) {
                    that.num = i
                }
            }
        }
        let userInfo = getUserInfo();
        this.queryTreeflxx()
    },
    methods: {
        // 退出登录
        tuichu() {
            let vm = this;
            let userInfo = getUserInfo();
            window.location.assign("https://lib.wtbu.edu.cn/whgs/api/caslogout")
            vm.userShow = true
        },
        focus() {
            this.placeholderValue = ""
        },
        blurinput() {
            this.placeholderValue = "站内搜索"
        },
        // 返回旧版
        fanhui() {
            window.open('http://lib.wtbu.edu.cn:5656/')
        },
        // 查询用户信息
        queryUserinfobycondition() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                userName: vm.link,
                type: 2,
            }
            queryUserinfobycondition(obj).then((res) => {
                this.$nextTick(() => {
                    this.userName = res.data[0].realName
                    this.userShow = false
                });
            });
        },
        handleScroll() {
            let vm = this
            let winHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (winHeight >= 200) {
                vm.topShow = true
            } else {
                vm.topShow = false
            }
        },
        // 去顶部
        goTop() {
            let vm = this
            let back = setInterval(() => {
                if (document.documentElement.scrollTop || document.body.scrollTop) {
                    document.documentElement.scrollTop -= 50;
                    document.body.scrollTop -= 50;
                } else {
                    clearInterval(back) //scrollTop到0时就移除定时器
                }
            }, 10)
        },
        // 站内搜索
        searchStationList() {
            let vm = this;
            this.$router.push({ name: "searchDetail", query: { title: vm.searchText } });
        },
        // 查看新闻管理模块
        // queryOneNewsCondition() {
        //     let vm = this;
        //     let userInfo = getUserInfo();
        //     var obj = {
        //         type: 10,
        //     }
        //     queryflxxbyCondition(obj).then((res) => {
        //         vm.newsArr = res.data.list
        //         vm.topNavData = res.data.list.slice(7)
        //         vm.newsArr = vm.newsArr.splice(0,6)
        //         vm.newsArr.forEach(item => {

        //         })
        //         vm.queryTreeflxx(item.id)
        //     });
        // },
        move(item, nav) {
            let vm = this
            vm.listNav = true
            vm.indexNav = nav
        },
        remove() {
            let vm = this
            vm.listNav = false
        },
        // 一级分类
        queryTreeflxx() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                type: 10
            }
            queryTreeflxx(obj).then((res) => {
                if (res.data == "") {

                } else {
                    vm.newserjiArr = res.data.splice(0, 10)
                }
            });
        },
        //一级分类跳转
        goDatial(item) {
            let vm = this
            if (item.name == "资源") {
                vm.parentId = item.childDisease[0].id
                this.$router.push({
                    name: "databasedetail",
                    query: { zyid: vm.parentId, id: item.id, parentId: vm.parentId, indexNav: 0 },
                });
            } else {
                if (item.childDisease.length == 0) {
                    vm.parentId = 0
                } else {
                    vm.parentId = item.childDisease[0].id
                }
                this.$router.push({
                    name: "detailList",
                    query: { id: item.id, parentId: vm.parentId, indexNav: 0 },
                });
            }
        },
        //快捷跳转
        kuaijieDatial(item, index) {
            let vm = this
            this.$router.push({
                name: "detailList",
                query: { id: vm.KuaijieId, parentId: item.id, indexNav: index },
            });
        },
        // 二级分类跳转
        goDatialList(item, aa, b) {
            let vm = this
            if (item.name == "资源") {
                // vm.zyid = aa.id
                this.$router.push({
                    name: "databasedetail",
                    query: { zyid: aa.id, id: item.id, parentId: aa.id, indexNav: b },
                });
            } else {
                this.$router.push({
                    name: "detailList",
                    query: { id: item.id, parentId: aa.id, indexNav: b },
                });
            }
            if (aa.name == "新书精品") {
                var obj = {
                    flType: 10,
                    flid: aa.id,
                    shstate: 2
                }
                queryXwxxbyCondition(obj).then((res) => {
                    this.$router.push({
                        name: "detail",
                        query: { id: res.data.list[0].id, },
                    });
                })
            }
        },
        denglu() {
            window.location.assign("https://lib.wtbu.edu.cn/whgs/api/caslogin?logintype=2")
            // window.location.assign("http://192.168.7.19:9020/api/caslogin")
        },

    }
}
</script>

<style scoped lang="scss">
.el-input {
    // margin-top: 15px;
    margin-right: 20px;
    padding: 0;
    font-size: 14px;
}

::v-deep .el-input .el-input__inner {
    // border: none;
    background-color: rgb(176, 37, 42);
    // border-bottom: 1px solid #fff;
    border-radius: 15px;
    font-size: 14px;
    color: #fff;
    font-size: 14px;
    // padding: 0;
    height: 25px;
    padding-right: 30px;
}

::v-deep  .el-input__inner::placeholder {
    color: #ccc;
    font-size: 14px;
}

#index {
    height: 114px;
}
// #login-div {
//     position: absolute;
//         right: -160px;
//             top: -90px;
// }
#header {
    position: relative;
}

// #firstSection #banner {
//     position: absolute;
//     width: 100%;
//     top: 0;
//     left: 0;
// }

#firstSection .grid-wrap {
    z-index: 100;
}

.grid-wrap {
    position: relative;
    margin: 0 auto;
    width: 1204px;
}

// .grid-stack {
//     position: relative;
//     border: 2px dotted transparent;
// }

.grid-wrap {
    overflow: hidden;
}

.bacList {
    background: url('../assets/images/bacList.png') no-repeat;
    background-size: 100% 100% !important;
}

.eng-search-style11 .el-icon-bottom {
    // position: absolute;
    right: 0;
    padding-right: 24px;
    line-height: 56px;
    font-size: 12px;
    cursor: pointer;
    font-size: 20px;
}

::v-deep .el-carousel .el-carousel__arrow--right {
    top: 70%;
}

// #index .grid-stack .grid-stack-item-content {
//     overflow-y: hidden;
// }
// .grid-stack>.grid-stack-item>.grid-stack-item-content {
//     margin: 0;
//     position: absolute;
//     top: 10px;
//     left: 10px;
//     right: 10px;
//     bottom: 10px;
//     width: auto;
//     overflow-x: hidden;
// }
</style>




// WEBPACK FOOTER //
// src/components/Header.vue